import React from 'react';
import PropTypes from 'prop-types';

import './MiniPreview.css';


import { APIs } from '../../constants/endPointsURLs';

class MiniPreview extends React.Component {
	state = {
		width: 0,
		height: 0,
		isImageLoaded: false,
	};

	canvasRef = React.createRef();
	imgEl = '';
	scheduler = '';

	componentDidMount() {
		const { isThereSignal, companyType } = this.props;

		let width;
		let height;
		if (companyType === 0) {
			width = 250;
		} else {
			width = 350;
		}
		height = width * 9 / 16;

		const canvas = this.canvasRef.current.getContext('2d');
		this.imgEl = document.createElement('img');
		this.imgEl.onload = () => {
			const canvasEl = this.canvasRef.current;
			if (!canvasEl) return;

			const { width, height } = canvasEl;
			const imgWidth = this.imgEl.naturalWidth;
			const imgHeight = this.imgEl.naturalHeight;

			// Clear canvas
			canvas.fillStyle = '#000000';
			canvas.fillRect(0, 0, width, height);

			if (imgWidth && imgHeight) {
				const ratio = Math.min(width / imgWidth, height / imgHeight);
				const drawWidth = imgWidth * ratio;
				const drawHeight = imgHeight * ratio;
				const x = (width - drawWidth) / 2;
				const y = (height - drawHeight) / 2;

				canvas.drawImage(this.imgEl, x, y, drawWidth, drawHeight);

				if (!this.state.isImageLoaded) {
					this.setState({ isImageLoaded: true });
				}
			} else {
				// Fallback if image dimensions aren't available
				canvas.drawImage(this.imgEl, 0, 0, width, height);

				if (!this.state.isImageLoaded) {
					this.setState({ isImageLoaded: true });
				}
			}
		};

		this.setState({ width: width, height: height }, () => {
			if (isThereSignal === true) {
				this.setScheduler();
			}
		});
	}

	componentDidUpdate(prevProps) {
		const { isThereSignal } = this.props;
		if (isThereSignal !== prevProps.isThereSignal) {
			if (isThereSignal === true) {
				this.setScheduler();
			} else {
				clearInterval(this.scheduler);
				this.clearCanvas();
			}
		}
	}

	componentWillUnmount() {
		clearInterval(this.scheduler);
		this.clearCanvas();
	}

	clearCanvas = () => {
		const canvasEl = this.canvasRef.current;
		this.setState({ isImageLoaded: false });
		if (canvasEl) {
			const ctx = canvasEl.getContext('2d');
			ctx.fillStyle = '#000000';
			ctx.fillRect(0, 0, canvasEl.width, canvasEl.height);
		}
	};

	setScheduler = () => {
		const { signalId } = this.props;
		this.imgEl.src = APIs.getBroadcastThumbnail(signalId) + '?t=' + new Date().getTime();
		this.scheduler = setInterval(() => {
			this.imgEl.src = APIs.getBroadcastThumbnail(signalId) + '?t=' + new Date().getTime();
		}, 1000);
	};

	render() {
		const { isThereSignal, isInput, companyType } = this.props;
		const { width, height } = this.state;

		return (
			<div className="mini-preview">
				<div className={`${isInput ? (companyType === 0 ? 'thumbnail-img-input' : 'thumbnail-img-input-extended') : 'thumbnail-img-output'} ${(isThereSignal && this.state.isImageLoaded)
					? 'd-none'
					: 'd-block'}`}
				/>

				<canvas
					className={(isThereSignal && this.state.isImageLoaded) ? 'd-block' : 'd-none'}
					ref={this.canvasRef}
					width={width}
					height={height}
				/>

			</div>
		);
	}
}

MiniPreview.propTypes = {
	signalId: PropTypes.number,
	isThereSignal: PropTypes.oneOf([undefined, false, true]),
	screenSize: PropTypes.string,
	isInput: PropTypes.oneOf([undefined, false, true])
};

export default MiniPreview;
